<template>
    <div class="live-item">
        <component :is="realData.component" :data="realData.data" :baseData="itemData" />
    </div>
</template>

<script>
import Living from '@components/liveList/Living';
import Subscribe from '@components/liveList/Subscribe';
import UnSubscribe from '@components/liveList/UnSubscribe';
import moment from '@plugins/_moment';
import { cloneDeep } from 'lodash';

export default {
    name: 'LiveItem',
    components: {
        Living,
        Subscribe,
        UnSubscribe
    },
    props: {
        itemData: {
            require: true,
            type: Object
        }
    },
    computed: {
        realData() {
            const itemData = cloneDeep(this.itemData);
            const lives = this.sortLiveData(itemData.lives.data);
            const realData = {
                component: UnSubscribe, // 未预约组件
                data: lives // 未预约传值
            };
            const live = Array.isArray(lives) ? lives.find((item) => item.am_i_reserved) : null;
            if (live) {
                switch (live.status) {
                    case 0:
                        realData.component = Subscribe; // 预约且未开播组件
                        realData.data = live; // 预约且未开播数据
                        break;
                    case 1:
                        realData.component = Subscribe; // 预约且未开播组件
                        realData.data = live; // 预约且未开播数据
                        break;
                    case 2:
                        realData.component = Living; // 直播中组件
                        realData.data = live; // 直播中数据
                        break;
                }
            }
            return realData;
        }
    },

    mounted() {
        // console.log(this.itemData);
    },

    methods: {
        sortLiveData(data) {
            if (!Array.isArray(data)) {
                return data;
            }
            return data.sort((a, b) => {
                const aDate = moment(a.live_start_time);
                const bDate = moment(b.live_start_time);
                if (aDate.isBefore(bDate)) {
                    return -1;
                } else if (aDate.isSame(bDate)) {
                    return 0;
                } else {
                    return 1;
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped></style>
